import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

function ViewConvenioFederal() {
  const [data, setData] = useState([]);
  const [isAdmin, setIsAdmin] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  function formatBRL(value) {
    if (!value) return "-";

    const num = Number(value);
    if (isNaN(num)) return "-";

    return num.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  }

  const carregarDados = () => {
    axios
      .get("/api/conveniosfederal")
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => {
        console.error("Erro no axios:", err);
        alert("Erro ao carregar dados do servidor");
      });
  };

  useEffect(() => {
    const userRole = localStorage.getItem("UserRole");
    setIsAdmin(userRole === "admin");
    carregarDados();
  }, []);

  const handleDelete = (id) => {
    if (window.confirm("Tem certeza que deseja deletar este convênio?")) {
      axios
        .delete(`/api/conveniosfederal/${id}`)
        .then((res) => {
          if (res.data.message === "Convenio deletado com sucesso!") {
            alert("Convênio deletado!");
            carregarDados();
          } else {
            alert("Erro ao deletar o convênio");
          }
        })
        .catch((err) => {
          console.error(err);
          alert("Erro no servidor");
        });
    }
  };

  return (
    <div className="fs-11 px-18 py-8" style={{ overflow: "visible" }}>
      <div className="d-flex justify-content-center mb-3">
        <h3>Convênios FEDERAL</h3>
      </div>

      <div className="mb-3 d-flex align-items-center gap-2 flex-wrap">
        {isAdmin && (
          <Link to="/addconvenios_federal" className="btn btn-primary">
            + Novo Convênio
          </Link>
        )}
        <Link to="/conveniosestadual" className="btn btn-secondary">
          Convênios ESTADUAL
        </Link>
        <Link to="/conveniosdade" className="btn btn-secondary">
          Convênios DADE
        </Link>
        <Link to="/conveniossempapel" className="btn btn-secondary">
          Convênios Sem Papel
        </Link>
        <Link to="/conveniosfinisa" className="btn btn-secondary">
          Convênios FINISA
        </Link>

        <input
          type="text"
          placeholder="Buscar por Objeto, Empresa, Conta..."
          className="form-control"
          style={{ maxWidth: "300px" }}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <div style={{ overflowX: "auto" }}>
        <table className="table table-responsive table-bordered table-hover">
          <thead className="table-primary">
            <tr>
              <th>ID</th>
              <th>Objeto</th>
              <th>Contrato</th>
              <th>Nº Convênio</th>
              <th>Ano</th>
              <th>Repasse (R$)</th>
              <th>Contrapartida (R$)</th>
              <th>Valor Total (R$)</th>
              <th>Vigência Convênio</th>
              <th>Vigência Contrato</th>
              <th>Empresa</th>
              <th>OIS</th>
              <th>Fiscal / Contador</th>
              <th>Conta Bancária</th>
              <th>Recurso Liberado</th>
              <th>Status</th>
              {isAdmin && <th>Ações</th>}
            </tr>
          </thead>

          <tbody>
            {data
              .filter((item) => {
                const search = searchTerm.toLowerCase();
                return [
                  item.objeto,
                  item.numero_convenio,
                  item.ano,
                  item.empresa,
                  item.fiscal,
                  item.conta_bancaria,
                  item.status,
                ].some((field) =>
                  field?.toString().toLowerCase().includes(search)
                );
              })
              .map((item) => (
                <tr key={item.id}>
                  <td>{item.id}</td>
                  <td>{item.objeto}</td>
                  <td>{item.contrato}</td>
                  <td>{item.numero_convenio}</td>
                  <td>{item.ano}</td>
                  <td>{formatBRL(item.repasse)}</td>
                  <td>{formatBRL(item.contrapartida)}</td>
                  <td>{formatBRL(item.valor_total)}</td>
                  <td>{item.vigencia_convenio}</td>
                  <td>{item.vigencia_contrato}</td>
                  <td>{item.empresa}</td>
                  <td>{item.ois}</td>
                  <td>{item.fiscal}</td>
                  <td>{item.conta_bancaria}</td>
                  <td>{item.recurso_liberado}</td>
                  <td>{item.status}</td>
                  {isAdmin && (
                    <td>
                      <button
                        className="btn btn-light btn-sm me-2"
                        onClick={() =>
                          navigate(`/editconveniofederal/${item.id}`)
                        }
                      >
                        Editar
                      </button>
                      <button
                        className="btn btn-info btn-sm"
                        onClick={() => handleDelete(item.id)}
                      >
                        Deletar
                      </button>
                    </td>
                  )}
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ViewConvenioFederal;
